import { Injectable } from '@angular/core';
import { PsModalLoadingComponent } from 'porto-seguro-guide';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loading: PsModalLoadingComponent;
  isOpen = false;

  constructor() {
  }

  toggle() {

    if (!this.isOpen) {
      this.loading.open(null);
      this.isOpen = true;
    } else {
      this.loading.close();
      this.isOpen = false;
    }
  }

  open() {
    this.loading.open(null);
  }

  close() {
    this.loading.close();
  }
}
